module.exports = __webpack_public_path__ + "dingbeauty-landing/img/industry_01@1.3404953d.png";